import script from "./ThumbnailField.vue?vue&type=script&setup=true&lang=js"
export * from "./ThumbnailField.vue?vue&type=script&setup=true&lang=js"

export default script